import React, { ChangeEvent, KeyboardEvent, useContext } from 'react';
import { Input, Button, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import useAttributeFilters from 'common/customHooks/useAttributeFilters';
import { SearchTextContext } from '../../../../../contexts';

const SearchInput = () => {

  const {
    setSearchText,
    showSearchInput,
    setShowSearchInput,
  } = useContext(SearchTextContext);
  const { setAttributeFiltersInUrl } = useAttributeFilters();

  const handleSearch = (event: KeyboardEvent<HTMLInputElement>) => {
    setSearchText((event.target as HTMLInputElement).value);
    setAttributeFiltersInUrl([]);
    setShowSearchInput(true);
  };

  const handleClear = (event: ChangeEvent) => {
    if(event.type === 'click'){
      // clear icon clicked
      setSearchText('');
      setAttributeFiltersInUrl([]);
      setShowSearchInput(false);
    }
  };

  return (
    <Space>
      {!showSearchInput && (
        <Button
          icon={<SearchOutlined />}
          onClick={() => setShowSearchInput(true)}
          size="large"
          type="default"
        >
          Search
        </Button>
      )}
      {showSearchInput && (
        <Input allowClear autoFocus onChange={handleClear} onPressEnter={handleSearch} placeholder="Search" prefix={<SearchOutlined />} size="large" />
      )}
    </Space>
  );
};

export default SearchInput;
